<style>
.bet-table-header{
    border-bottom: 0px solid #c7c8ca;
    border-top: 0px solid #c7c8ca;
    padding: 0px 0;}
    
    .odd-box{
        border-radius: 4px;
    cursor: pointer;
    display: inline-block;
    float: left;
    font-size: 14px;
    line-height: 13px !important;
    padding: 5px 0;
    width: 49% !important;
        margin-right: 0.5%;
    }
    .bet-table-row
    {padding: 2px 1px;}
    
   
    .bet-nation-game-name span {
        color: #000 !important;
    font-family: Roboto Condensed, sans-serif !important;
    font-weight: 700 !important;
            cursor: pointer;
    display: inline-block;
    font-weight: 700;
    line-height: 17px;
    max-width: 750px !important;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
}
    }
    
    .over-wrap {
    overflow: hidden;
    overflow-y: auto;
}
/* Hide on mobile (less than 768px) */
.goneonmobile {
  display: none;
}

/* Show on desktop (768px and up) */
@media (min-width: 768px) {
  .goneonmobile {
    display: block;
      

  }
  .mbmb1oa{
      width:84%;
  }
}

</style>

<div class="row">
    
                    <div class="col-left col-left-login goneonmobile" style="width: 16%; background-color: #FFF;" id="sidebar"><div class="sub_path over-wrap">
                <ul class="list-unstyled components">
  <p style=" background-color: #072c50;
    color: #fff;     margin: 0;
    padding: 2px 7px;
    text-transform: capitalize;">Popular <i class="fa fa-close pt-1 icon-toggle-right mobile-menu float-right"></i></p>
<style>
element.style {
    text-transform: capitalize;
}
#sidebar ul li a {
    border-bottom: 1px solid #e8e8e8;
    color: #000;
}
#sidebar ul li a {
    align-items: center;
    display: flex
;
    padding: 8px 10px;
}
#sidebar ul li a, #sidebar ul p {
    font-family: Roboto Condensed, sans-serif;
    font-size: 14px;
    font-weight: 700;
}
a[data-toggle=collapse] {
    position: relative;
}
a:not([href]), a:not([href]):hover {
    color: inherit;
    text-decoration: none;
}
.dropdown-toggle {
    white-space: nowrap;
}
a, a:active, a:focus, a:hover {
    outline: none;
    text-decoration: none;
}
a {
    color: #fff;
    cursor: pointer;
    text-decoration: none;
}
a {
    background-color: transparent;
    color: #007bff;
}
#sidebar ul li a:hover {
    background-color: #f8bd23;
    color: #000;
}
.list-unstyled.components .sports-icon {
    background-position: 0 -900px;
    background-repeat: no-repeat;
    background-size: 28px auto;
    display: inline-block;
    height: 24px;
    margin-right: 5px;
    overflow: hidden;
    vertical-align: bottom;
    width: 28px;
    background-image: url(https://images.staticcontent.io/casino/banner/images/sports-icons.png);
}
#sidebar ul li dropdown-toggle:hover {
    background-color: #f8bd23;
}

.dropdown-toggle::after {
        display: block;
    font-size: 16px;
    position: absolute;
   
        left: 14%;

    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    
    #sidetree {
    background: #e1e4ef;
    font-size: 12px;
    padding: 2px 5px;
}
}
</style>
 

  <li>
    <a aria-expanded="true"><span class="sports-icon inplayside" style=" background-position: 0 -1527px;"></span> In-Play</a>
  </li>

  <li>
    <a href="/ipl"><span class="sports-icon iplwinnerside" style="background-position: 0 -1775px;"></span> IPL 2025</a>
  </li>

  <li>
    <a class="dropdown-toggle"><span class="sports-icon cricketside" style="background-position: 0 -326px;"></span> Cricket</a>
    <div id="sidetree" style="display: none;">
      <ul>
        <li class="treeview">
          <span class="treeviewnode">Indian Premier League</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Royal Challengers Bengaluru v Rajasthan Royals</span></li>
            <li class="treeview"><span class="treeviewnode">Kolkata Knight Riders v Punjab Kings</span></li>
            <li class="treeview"><span class="treeviewnode">Chennai Super Kings v Sunrisers Hyderabad</span></li>
            <li class="treeview"><span class="treeviewnode">Mumbai Indians v Lucknow Super Giants</span></li>
          </ul>
        </li>
        <li class="treeview">
          <span class="treeviewnode">Womens One Day Internationals</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Sri Lanka Women v India Women</span></li>
          </ul>
        </li>
        <li class="treeview">
          <span class="treeviewnode">International Twenty20 Matches</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Canada v USA</span></li>
          </ul>
        </li>
        <li class="treeview">
          <span class="treeviewnode">Pakistan Super League</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Quetta Gladiators v Karachi Kings</span></li>
            <li class="treeview"><span class="treeviewnode">Lahore Qalandars v Peshawar Zalmi</span></li>
          </ul>
        </li>
        <li class="treeview">
          <span class="treeviewnode">Test Matches</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Bangladesh v Zimbabwe</span></li>
          </ul>
        </li>
      </ul>
    </div>
  </li>

  <li>
    <a class="dropdown-toggle"><span class="sports-icon soccerside" style="background-position: 0 -1026px;"></span> Soccer</a>
    <div id="sidetree" style="display: none;">
      <ul>
        <li class="treeview">
          <span class="treeviewnode">Spanish La Liga</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Getafe v Real Madrid</span></li>
            <li class="treeview"><span class="treeviewnode">Alaves v Real Sociedad</span></li>
            <li class="treeview"><span class="treeviewnode">Leganes v Girona</span></li>
            <li class="treeview"><span class="treeviewnode">Osasuna v Sevilla</span></li>
            <li class="treeview"><span class="treeviewnode">Atletico Madrid v Rayo Vallecano</span></li>
            <li class="treeview"><span class="treeviewnode">Betis v Valladolid</span></li>
          </ul>
        </li>
        <li class="treeview">
          <span class="treeviewnode">Dutch Eredivisie</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Az Alkmaar v NAC Breda</span></li>
            <li class="treeview"><span class="treeviewnode">FC Twente v PSV</span></li>
          </ul>
        </li>
        <li class="treeview">
          <span class="treeviewnode">English Premier League</span>
          <ul>
            <li class="treeview"><span class="treeviewnode">Arsenal v Crystal Palace</span></li>
          </ul>
        </li>
      </ul>
    </div>
  </li>
 

<li>
    <a href="./dashboard/livecasino?vendorId=SPB"><span class="" style="    height: 18px;
    margin-left: 0;
    margin-right: 5px;
    width: 18px; background-position: 0 -1775px;"><img style="    height: 18px;
    margin-left: 0;
    margin-right: 5px;
    width: 18px;" class="ball-images-tab" src="https://images.staticcontent.io/casino/banner/images/aviator-icon.svg" alt=""></span> Aviator</a>
</li>

<li 
    >
  
   <a href="./dashboard/livecasino?vendorId=AWC"><span class="sports-icon iplwinnerside" style="background-position: 0 -863px;"></span>
      AE Sexy
    </a>
</li>
<li *ngFor="let vendor of vendors"
    >
  
   <a href="./dashboard/livecasino?vendorId={{ vendor.providerCode }}"><span class="sports-icon iplwinnerside" style="background-position: 0 -863px;"></span>
      {{ vendor.providerName }}
    </a>

   

  <!--<ul class="dropdown-menu" style="background-color: #edf0fa; border-radius: 5px; padding: 10px; min-width: 240px;">-->
  <!--  <li *ngFor="let category of categories" style="display: flex; align-items: center; justify-content: space-between; padding: 6px 0; border-bottom: 1px solid #ddd;">-->
      
  <!--    <a class="dropdown-item" href="javascript:void(0);" -->
  <!--       (click)="onSelectCategory(category); onVendorChange(vendor.providerCode)"-->
  <!--       style="text-decoration: none; color: #000; padding-left: 10px; border-left: 2px solid #007bff; flex-grow: 1;">-->
  <!--      {{ category }}-->
  <!--    </a>-->

  <!--    <span style="display: inline-block; background-color: #fff; border: 1px solid #ccc; padding: 0px 5px; font-weight: bold; font-size: 14px; margin-left: 10px;">+</span>-->
  <!--  </li>-->
  <!--</ul>-->
</li>



</ul>
</div>
</div>

<div class="content-wrapper mbmb1oa" style="min-height: 368px">
  <div style="background: #e9eff8;" class="card-header font-weight-bold rounded text-dark p-0 d-flex justify-content-between align-items-center" style="display:none !important;">
    <span class="newhead">
       INT CASINO</span>
       <div>
        <input
          type="text"
          class="form-control searchinput"
          placeholder="Search Game"
          style="width: 200px; height: 30px; background-color: black; color: white;"
          (input)="onSearch($event)"
        />
      </div>
   </div>
   <style>
  .nav-link.active {
    background: linear-gradient(180deg, #f9bd23 0%, #f9bd23 100%) !important;
    border-radius: 5px;
  }
  .int_sub_navbar a active, .int_sub_navbar li a:hover {
    background: transparent linear-gradient(180deg, #000 0%, #000 100%) !important;
    color: #fff !important;
}
</style>

   <div class="sub_path center-box"><p style="
    background-color: #072c50;
    color: #fff;    font-family: Roboto Condensed, sans-serif;
    font-size: 14px;
    font-weight: 700;
    height: 28px;
    line-height: 19px;
    margin: 0;
    padding: 6px 10px 6px 7px;
    text-transform: capitalize;
}">Casino</p></div>
    <div class="pt-2 pb-2">
      <div *ngIf="is_active; else notActive">
      <div class="exchange-menu-wrapper int_all_tab " style="
    height: 40px;
    display: flex
;
    background: #f8bd23;
    justify-content: center;
    align-items: center;">
        <!--<ul  role="tablist" class="nav nav-pills subnav" aria-label="Tabs">-->
        <!--  <li class="nav-item lobbytab" (click)="openLobby()">-->
        <!--    <a href="javascript:void(0);" role="tab" class="nav-link">-->
        <!--      <span>Lobby</span>-->
        <!--    </a>-->
        <!--  </li>-->
        <!--  <li *ngFor="let vendor of vendors" class="nav-item" [class.active]="activeVendor==vendor.providerCode" (click)="onVendorChange(vendor.providerCode)">-->
        <!--      <a  href="javascript:void(0);" role="tab" class="nav-link" [class.active]="activeVendor==vendor" id="">-->
        <!--        <span id="parentTab-0"> {{ vendor.providerName }} </span>-->
        <!--      </a>-->
        <!--  </li>-->
        <!--</ul>-->
        <ul role="tablist" class="nav nav-pills int_sub_navbar" style="
    background: #f8bd23;
    height: 40px;
    align-items: center;
    overflow-x: auto;
    display: flex;" aria-label="Tabs" style="background: #f8bd23;">
          <li class="nav-item" (click)="onSelectCategory('Popular')" [class.active]="activeCategory === 'Popular'">
            <a href="javascript:void(0);" role="tab" class="nav-link" [class.active]="activeCategory === 'Popular'">
              <span style="font-weight:700;">Popular</span>
            </a>
          </li>
          <li class="nav-item" (click)="onSelectCategory('All')" [class.active]="activeCategory === 'All'">
            <a href="javascript:void(0);" role="tab" class="nav-link" [class.active]="activeCategory === 'All'">
              <span style="font-weight:700;">All</span>
            </a>
          </li>
          <li *ngFor="let category of categories; let i = index" class="nav-item" (click)="onSelectCategory(category)" [class.active]="category === activeCategory">
            <a href="javascript:void(0);" role="tab" class="nav-link" [class.active]="category === activeCategory">
              <span style="font-weight:700;">{{category}} </span>
            </a>
          </li>
        </ul>
      </div>
      <div class="card m-0" style="">
          <div class="card-body" style="padding: 5px;">
              <div id="game_container">
              <div *ngIf="gameurl==''; else gameWindow">
                        <div *ngIf="isloading; else gamelist">
                          <mat-spinner diameter="40"></mat-spinner> 
                        </div> 
                        <ng-template #gamelist>
                          <div *ngIf="filtered_gameList.length > 0 && activeCategory!='search';" class="pagination">
                            <button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">previous</button>
                          
                            <ng-container *ngFor="let page of getPaginationRange()">
                              <ng-container *ngIf="page === '...'">
                                <span>...</span>
                              </ng-container>
                              <ng-container *ngIf="page !== '...'">
                                <button 
                                  (click)="page !== currentPage && changePage(page)" 
                                  [ngClass]="{'active-page': page === currentPage}"
                                >
                                  {{ page }}
                                </button>
                              </ng-container>
                            </ng-container>
                          
                            <button (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages">next</button>
                          </div>
                    <style>
  .casino-wrapper {
    width: 100%;
    margin: 0;
    padding: 0;
    background-color: transparent !important;
  }

  .game-grid-custom {
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* mobile: 2 columns */
    gap: 10px;
    padding: 10px;
    box-sizing: border-box;
    width: 100%;
  }

  @media (min-width: 992px) {
    .game-grid-custom {
      grid-template-columns: repeat(6, 1fr); /* desktop: 6 columns */
    }
  }

  .game-tile {
    border-radius: 15px;
    overflow: hidden;
    position: relative;
    width: 100%;
  }

  .game-image {
    width: 100%;
    height: 100%;
    border-radius: 15px;
    object-fit: cover;
    clip-path: inset(5px 5px 5px 5px round 12px);
    display: block;
    border: none;
  }
</style>

<div class="casino-wrapper">
  <section *ngIf="filtered_gameList.length > 0; else gamesfound" class="game-grid-custom">
    <div *ngFor="let game of filtered_gameList" class="game-tile">
      <img
        class="game-image"
        (click)="openNewGameTab(game.casinoGameId, game.provider)"
        alt="{{ game.game_name }}"
        src="{{ game.logo_square }}"
        (error)="onImageError($event)"
      />
    </div>
  </section>
</div>
                        </ng-template> 
                        <ng-template #gamesfound>
                          <h5>no games found</h5>
                        </ng-template>
              </div>
              <ng-template #gameWindow>
                <div class="col-md-12 mt-4 p-0">
                  <iframe [src]="gameurl" width="100%" height="600px" title="game"></iframe>
                </div>
              </ng-template>
              </div>
          </div>
      </div>
      </div>
      <ng-template #notActive>
        <div class="pt-4 text-center" id="contact_us">
          <h3 class="contact_notice">Notice: Your casino account is not active, click to active.</h3>
          <br>
          <button type="button" [disabled]="clicked" (click)="activateAccount(); clicked = true;" class="btn btn-primary btn-lg mt-3 text-dark">Activate account</button>
        </div>
      </ng-template>
    </div>
</div>
</div>